"use client";

import type { TopNavItem } from "@/lib/top-nav";
import { useContext } from "react";
import { useState } from "react";
import { createContext, ReactNode } from "react";

interface NavContextType {
  navRetracted?: boolean;
  setNavRetracted: (arg0: boolean) => void;
  showAnnouncement?: boolean;
  setShowAnnouncement: (arg0: boolean) => void;
  showMainNav?: boolean;
  setShowMainNav: (arg0: boolean) => void;
  topNavItems: TopNavItem[];
}

export const NavContext = createContext<NavContextType>({
  navRetracted: false,
  setNavRetracted: () => {},
  showAnnouncement: false,
  setShowAnnouncement: () => {},
  showMainNav: true,
  setShowMainNav: () => {},
  topNavItems: [],
});

interface NavProviderProps {
  children: ReactNode;
  topNavItems?: TopNavItem[];
}

export const NavContextProvider = NavContext.Provider;

export function NavProvider({
  children,
  topNavItems = [],
}: NavProviderProps) {
  const [navRetracted, setNavRetracted] = useState(false);
  const [showAnnouncement, setShowAnnouncement] = useState(false);
  const [showMainNav, setShowMainNav] = useState(true);

  return (
    <NavContextProvider
      value={{
        navRetracted,
        setNavRetracted,
        showAnnouncement,
        setShowAnnouncement,
        showMainNav,
        setShowMainNav,
        topNavItems,
      }}
    >
      {children}
    </NavContextProvider>
  );
}

export function useNav() {
  const context = useContext(NavContext);
  if (context === undefined) {
    throw new Error("useNav must be used within a NavProvider");
  }
  return context;
}
